module.exports = __webpack_public_path__ + "img/Weapon_04.c8d889de.png";